module.exports = __webpack_public_path__ + "img/csr-sb1-2.dd7e621b.jpg";